import { render, staticRenderFns } from "./Equipo.vue?vue&type=template&id=71c11f01&scoped=true"
import script from "./Equipo.vue?vue&type=script&lang=js"
export * from "./Equipo.vue?vue&type=script&lang=js"
import style0 from "./Equipo.vue?vue&type=style&index=0&id=71c11f01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c11f01",
  null
  
)

export default component.exports